module.exports = __webpack_public_path__ + "img/DASHBOARD.a9600fd2.png";